if (!customElements.get('desktop-card-images')) {
  customElements.define('desktop-card-images', class extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      this.onChange = () => this.update();
      this.media.addEventListener('change', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      this.media.removeEventListener('change', this.onChange);
      this.observer?.disconnect();
      this.layer?.remove();
      this.layer = null;
    }

    update() {
      this.observer?.disconnect();
      if (!this.media.matches) {
        this.layer?.remove();
        this.layer = null;
        return;
      }
      if (this.layer) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.mount();
        }
      }, {rootMargin: '300px'});
      this.observer.observe(this.closest('[data-product-image]') || this);
    }

    mount() {
      if (!this.media.matches || this.layer || !this.isConnected) return;
      const template = this.querySelector('template');
      if (!template) return;
      const fragment = template.content.cloneNode(true);
      const layer = fragment.querySelector('hover-images');
      if (!layer) return;
      this.layer = layer;
      const images = Array.from(layer.querySelectorAll('img'));
      const ready = images.map(image => new Promise(resolve => {
        const finish = () => {
          image.removeEventListener('load', finish);
          image.removeEventListener('error', finish);
          if (image.naturalWidth > 0) {
            image.classList.remove('is-loading');
            image.closest('.lazy-image')?.classList.remove('is-loading');
          }
          resolve(image.naturalWidth > 0);
        };
        image.loading = 'eager';
        image.fetchPriority = 'low';
        image.addEventListener('load', finish);
        image.addEventListener('error', finish);
        queueMicrotask(() => { if (image.complete) finish(); });
      }));
      this.append(fragment);
      Promise.all(ready).then(results => {
        if (this.layer === layer && this.isConnected && results.every(Boolean)) {
          layer.style.removeProperty('visibility');
        }
      });
    }
  });
}
